import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { 
  Users, 
  Clock, 
  Camera, 
  MapPin, 
  TrendingUp, 
  CheckCircle 
} from 'lucide-react';

interface StatsData {
  totalUsers: number;
  activeUsers: number;
  totalReports: number;
  avgWaitTime: number;
  activeCrossings: number;
  reportsWithPhotos: number;
}

interface StatsOverviewProps {
  stats: StatsData;
  isSpanish: boolean;
}

const StatsOverview: React.FC<StatsOverviewProps> = ({ stats, isSpanish }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-6">
      <Card className="hover:shadow-lg transition-shadow">
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-3">
          <CardTitle className="text-base font-medium">
            {isSpanish ? 'Usuarios Totales' : 'Total Users'}
          </CardTitle>
          <Users className="h-5 w-5 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-3xl font-bold tracking-tight">{stats.totalUsers}</div>
          <p className="text-sm text-muted-foreground mt-1">
            {isSpanish ? 'registrados' : 'registered'}
          </p>
        </CardContent>
      </Card>

      <Card className="hover:shadow-lg transition-shadow">
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-3">
          <CardTitle className="text-base font-medium">
            {isSpanish ? 'Usuarios Activos' : 'Active Users'}
          </CardTitle>
          <TrendingUp className="h-5 w-5 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-3xl font-bold tracking-tight">{stats.activeUsers}</div>
          <p className="text-sm text-muted-foreground mt-1">
            {isSpanish ? 'estado activo' : 'active status'}
          </p>
        </CardContent>
      </Card>

      <Card className="hover:shadow-lg transition-shadow">
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-3">
          <CardTitle className="text-base font-medium">
            {isSpanish ? 'Check-ins Totales' : 'Total Check-ins'}
          </CardTitle>
          <MapPin className="h-5 w-5 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-3xl font-bold tracking-tight">{stats.totalReports}</div>
          <p className="text-sm text-muted-foreground mt-1">
            {isSpanish ? 'reportes' : 'reports'}
          </p>
        </CardContent>
      </Card>

      <Card className="hover:shadow-lg transition-shadow">
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-3">
          <CardTitle className="text-base font-medium">
            {isSpanish ? 'Tiempo Promedio' : 'Avg Wait Time'}
          </CardTitle>
          <Clock className="h-5 w-5 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-3xl font-bold tracking-tight">{stats.avgWaitTime}m</div>
          <p className="text-sm text-muted-foreground mt-1">
            {isSpanish ? 'estimado' : 'estimated'}
          </p>
        </CardContent>
      </Card>

      <Card className="hover:shadow-lg transition-shadow">
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-3">
          <CardTitle className="text-base font-medium">
            {isSpanish ? 'Cruces Activos' : 'Active Crossings'}
          </CardTitle>
          <CheckCircle className="h-5 w-5 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-3xl font-bold tracking-tight">{stats.activeCrossings}</div>
          <p className="text-sm text-muted-foreground mt-1">
            {isSpanish ? 'operativos' : 'operational'}
          </p>
        </CardContent>
      </Card>

      <Card className="hover:shadow-lg transition-shadow">
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-3">
          <CardTitle className="text-base font-medium">
            {isSpanish ? 'Con Fotos' : 'With Photos'}
          </CardTitle>
          <Camera className="h-5 w-5 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-3xl font-bold tracking-tight">{stats.reportsWithPhotos}</div>
          <p className="text-sm text-muted-foreground mt-1">
            {isSpanish ? 'fotos subidas' : 'photos uploaded'}
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default StatsOverview;